import { JSX } from "react";

export const AcceleratedUnderline = ({
  ...props
}: JSX.IntrinsicElements["svg"]) => {
  return (
    <svg
      viewBox="0 0 364 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6 8C115.723 2.50566 233.736 10.5462 358 6.25789"
        stroke="#CFB2FF"
        stroke-width="12"
        stroke-linecap="round"
      />
    </svg>
  );
};
